module.exports = __webpack_public_path__ + "img/avanzar-figura.3b506f6f.svg";